<template>
    <input type="hidden" :value="value">
</template>

<script>
import { controlMixins } from "./controlMixins.js";

export const hiddenComponent = {
    mixins: [controlMixins],
};

export default hiddenComponent;
</script>
